import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IApplicationToClose, ISettings, ISource } from './interfaces';

export const getApplicationToCloseAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/callcenter/appAvailableColumns')
    .then((response) => response.data);
};

export const getApplicationToCloseAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/callcenter/appAvailableGroupColumns')
    .then((response) => response.data);
};

export const getApplicationToCloseList = (data: IDynamicTableParams) => {
  return instance()
    .post<IApplicationToClose[]>('/callcenter/listApplications', data)
    .then((response) => response.data);
};

export const closeApplicationList = (contactPhone: string) => {
  return instance()
    .post('/callcenter/finish', { contactPhone })
    .then((response) => response.data);
};

export const getSources = () => {
  return instance()
    .post<ISource[]>('/dictionary/source', {})
    .then((response) => response.data);
};

export const getPhoneNumber = (data: ISettings) => {
  return instance()
    .post<string>('/callcenter/nextNumber', data)
    .then((response) => response.data);
};

export const saveSettings = (data: ISettings) => {
  return instance()
    .post('/callcenter/saveSettings', data)
    .then((response) => response.data);
};

export const resetSettings = () => {
  return instance()
    .post('/callcenter/resetSettings')
    .then((response) => response.data);
};
